export default {
  fullscreenToggle: false,
  seekToLive: false,
  pictureInPictureToggle: false,
};
